import { MaxAgeRange, MaxExpRange, MaxSalaryRange } from '../../../shared/consts/shared.const';
import { FilterForm } from '../models/filter-form.models';
import { isDefaultRange } from '../utils/functions';

export class QueryBuilder {
  Icat = '';
  industry = '';
  category = '';
  org = '';
  jobNature = '';
  Fcat = '';
  location = '';
  Qot = '';
  jobType = '';
  jobLevel = '';
  postedWithin = '';
  deadline = '';
  keyword = '';
  pg = '';
  qAge = '';
  Salary = '';
  experience = '';
  gender = '';
  MExp = '';
  genderB = '';
  MPostings = '';
  MCat = '';
  version = '';
  rpp = '';
  Newspaper = '';
  armyp = '';
  QDisablePerson = '';
  pwd = '';
  workplace = '';
  facilitiesForPWD = '';
  SaveFilterList = '';
  UserFilterName = '';
  HUserFilterName = '';
  earlyJobAccess = '';
  ToggleJobs!:boolean;
  isFresher:boolean = false;

  constructor(filterData: FilterForm | null, pageNo: number = 1, jobPerPage = 30, toggleJobs:boolean) {
    this.pg = pageNo.toString();
    this.rpp = jobPerPage.toString();
    this.ToggleJobs = toggleJobs;
    if (filterData) {
      if (filterData.industry && filterData.industry.length) {
        this.industry = filterData.industry[0].value;
      }
      if (filterData.category && filterData.category.length) {
        this.category = filterData.category[0].value;
      }
      if (filterData.location && filterData.location.length) {
        this.location = filterData.location[0].value;
      }
      if (filterData.jobNature) {
        this.jobNature = filterData.jobNature;
      }
      if (filterData.jobLevel) {
        this.jobLevel = filterData.jobLevel;
      }
      if (filterData.postedWithin) {
        this.postedWithin = filterData.postedWithin;
      }
      if (filterData.deadline) {
        this.deadline = filterData.deadline;
      }
      if (filterData.keyword) {
        this.keyword = filterData.keyword;
      }
      if (filterData.ageRange && filterData.ageRange.length) {
        if (!isDefaultRange(filterData.ageRange, MaxAgeRange)) {
          this.qAge = filterData.ageRange.join('/');
        }
      }
      if (filterData.salaryRange && filterData.salaryRange.length) {
        if (!isDefaultRange(filterData.salaryRange, MaxSalaryRange)) {
          this.Salary = filterData.salaryRange.join('/');
        }
      }
      if (filterData.expRange && filterData.expRange.length) {
        if (!isDefaultRange(filterData.expRange, MaxExpRange)) {
          this.experience = filterData.expRange.join('/');
        }
      }
      // if (filterData.experience) {
      //   this.experience = filterData.experience;
      // }
      if (filterData.gender) {
        this.gender = filterData.gender;
      }
      if (filterData.newspaperJob) {
        this.Newspaper = filterData.newspaperJob.id.toString();
      }
      if (filterData.isPreferredArmy) {
        this.armyp = filterData.isPreferredArmy ? 'yes' : ''
      }
      if (filterData.isWorkFromHome) {
        this.workplace = filterData.isWorkFromHome ? '1' : '0';
      }
      if (filterData.isAccessibleForDisabled) {
        this.facilitiesForPWD = filterData.isAccessibleForDisabled ? '1' : '0';
      }
      if (filterData.isEarlyAccessJobs) {
        this.earlyJobAccess = 'true';
      }
      if (filterData.organization && filterData.organization.length) {
        this.org =filterData.organization[0].value;
      }
      if(filterData.isFresher){
        this.isFresher = true
      }
    }
  }
}
